import { useMemo, useRef, useState } from "react";
import { MultiSelect } from "primereact/multiselect";

import { Location } from "./Location";
import { useAppSelector } from "../../common/hooks/useStore";
import { selectLocationsByIds, selectLocationsBySearchTerm } from "./locationsSlice";
import { NoResultsFoundText } from "../../common/components/noResultsFound/NoResultsFound";
import LocationFilterInput from "./LocationFilterInput";

interface LocationsMultiSelectProps {
  value?: string[];
  showClear?: boolean;
  onChange: (locationIds: string[]) => void;
}

export default function LocationsMultiSelect({ value, showClear, onChange }: LocationsMultiSelectProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const selectedLocations = useAppSelector((state) => selectLocationsByIds(state, value));
  const filteredLocations = useAppSelector((state) => selectLocationsBySearchTerm(state, searchTerm));

  const options = useMemo(() => {
    if (!selectedLocations.length) {
      return filteredLocations;
    }

    const missingSelectedLocations = selectedLocations.filter((location) => !filteredLocations.some((loc) => loc.id === location.id));
    return [...missingSelectedLocations, ...filteredLocations];
  }, [filteredLocations, selectedLocations]);

  return (
    <MultiSelect
      placeholder="Selecteaza locatia"
      optionLabel="name"
      options={options}
      value={selectedLocations}
      showClear={showClear}
      filter
      filterTemplate={<LocationFilterInput value={searchTerm} onChange={setSearchTerm} ref={inputRef} />}
      emptyMessage={NoResultsFoundText}
      onChange={(e) => onChange(e.value.map((location: Location) => location.id))}
      onHide={() => setSearchTerm("")}
    />
  );
}
